import React from 'react';

export type BrandLogoVariant = 'full' | 'mark';
export type BrandLogoColorMode = 'light' | 'dark';

type LogoSourceMap = Record<BrandLogoVariant, Record<BrandLogoColorMode, string>>;

const LOGO_SOURCES: LogoSourceMap = {
  full: {
    light: '/brand/blend-full-logo-light.svg',
    dark: '/brand/blend-full-logo-dark.svg',
  },
  mark: {
    light: '/brand/blend-logomark-light.svg',
    dark: '/brand/blend-logomark-dark.svg',
  },
};

export interface BrandLogoProps extends Omit<React.ImgHTMLAttributes<HTMLImageElement>, 'src'> {
  variant?: BrandLogoVariant;
  colorMode?: BrandLogoColorMode;
}

/** Official Blend logo asset with light/dark background-aware variants. */
export const BrandLogo: React.FC<BrandLogoProps> = ({
  variant = 'full',
  colorMode = 'light',
  alt,
  className,
  ...props
}) => {
  const classes = ['blend-logo', `blend-logo--${variant}`, className].filter(Boolean).join(' ');
  const fallbackAlt = variant === 'mark' ? 'Blend logomark' : 'Blend logo';

  return (
    <img
      {...props}
      src={LOGO_SOURCES[variant][colorMode]}
      alt={alt ?? fallbackAlt}
      className={classes}
    />
  );
};

export default BrandLogo;
